import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import resetReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ResetReCaptcha";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import { HasToasterContext, withToaster } from "@insite/mobius/Toast/ToasterContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    customCallBack: any;
    location: string;
}

const mapStateToProps = (state: ApplicationState, { location }: OwnProps) => {
    const { websiteSettings } = getSettingsCollection(state);
    const session = getSession(state);
    return {
        siteKey: websiteSettings.reCaptchaSiteKey,
        isEnabled: (websiteSettings as { [key: string]: any })[`reCaptchaEnabledFor${location}`],
        isAuthenticated: session && (session.isAuthenticated || session.rememberMe) && !session.isGuest,
        errorMessage: state.components.reCaptcha.errorMessage,
        location,
    };
};

const mapDispatchToProps = {
    resetReCaptcha,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasToasterContext;

export interface ReCaptchaStyles {
    wrapper?: InjectableCss;
}

export const reCaptchaStyles: ReCaptchaStyles = {};

const styles = reCaptchaStyles;

const CustomReCaptcha = ({
    siteKey,
    isEnabled,
    isAuthenticated,
    toaster,
    customCallBack,
    location,
    resetReCaptcha,
}: Props) => {
    const [firstRender, setFirstRender] = useState(true);
    useEffect(() => {
        setFirstRender(false);
        resetReCaptcha({ location });
    }, []);

    if (firstRender || !isEnabled || isAuthenticated) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} id="reCaptcha">
            <ReCAPTCHA
                sitekey={siteKey}
                onChange={customCallBack}
                onErrored={() => {
                    toaster.addToast({
                        body: translate("Something went wrong with RECAPTCHA, try again later."),
                        messageType: "danger",
                    });
                }}
            />
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withToaster(CustomReCaptcha));
